import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

/**
 * Styled container component for progress bar in pause ad modal.
 * Displays the playback progress indicator for the paused content.
 */
const PauseAdPlayIconContainer = styled.div`
  background: rgba(255, 255, 255, 0.5);
  position: absolute;
  overflow: hidden;
  border-radius: ${15 * Screen.widthRatio}px;
  top: ${125 * Screen.widthRatio}px;
  width: ${427 * Screen.widthRatio}px;
  height: ${11 * Screen.widthRatio}px;
`;

export default PauseAdPlayIconContainer;
